import type { Setting } from '@morph-mapper/plugins';

export type PluginConfigItem = {
  key: string;
  name: string;
  version: string;
  description?: string;
  settings: Setting[];
  enabled: boolean;
};

export const togglePluginEnabled = <T extends PluginConfigItem>(
  plugins: T[],
  pluginKey: string,
): T[] =>
  plugins.map((plugin) =>
    plugin.key === pluginKey ? { ...plugin, enabled: !plugin.enabled } : plugin,
  );

export const withPluginSetting = <T extends PluginConfigItem>(
  plugins: T[],
  pluginKey: string,
  settingKey: string,
  value: unknown,
): T[] =>
  plugins.map((plugin) =>
    plugin.key !== pluginKey
      ? plugin
      : {
          ...plugin,
          settings: plugin.settings.map((setting) =>
            setting.key === settingKey ? { ...setting, value } : setting,
          ),
        },
  );

export const setAllPluginsEnabled = <T extends PluginConfigItem>(
  plugins: T[],
  enabled: boolean,
): T[] => plugins.map((plugin) => ({ ...plugin, enabled }));
